export default "__VITE_ASSET__D5YIk5LN__"